var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{ref:"$el",class:{ flex: true, 'flex-col': _setup.isGrid, 'flex-row items-end': !_setup.isGrid, 'justify-between': _setup.isMap },on:{"long-press":function($event){return _vm.$emit('long-press', $event)}}},[_c(_setup.SurfaceSectionTitle,{ref:'sectionTitleRef',class:[_setup.isMap && 'me-3 desktop:me-2.5', 'surface-group-title', _setup.isGrid && 'max-w-[calc(100%-6px)]'],attrs:{"id":`section-title-${_vm.section.id}`,"background-color":_vm.useDefaultBgColor ? undefined : _setup.skinPrimaryVariantColorAsRGB || _setup.backgroundColor,"can-edit-inline":!_setup.isSmallerThanTabletLandscape && _setup.canIModerate && !_setup.isSectionBreakout,"dark-mode":_setup.backgroundLuminance === 'dark',"dir":_setup.dir,"edit-mode":_vm.section.id === _setup.sectionBeingRenamedId,"x-more-button":!_setup.isReadOnly,"font-id":_setup.fontId,"format":_setup.format,"title":_vm.section.title},on:{"click":function($event){_setup.allowOpenSectionActionMenu && _setup.openSectionActionMenu(_vm.section.id)},"open-actions":(e) => _setup.openSectionActionMenu(_vm.section.id, e),"start-editing":function($event){return _setup.startEditingSectionTitle(_vm.section.id)},"finish-editing":_setup.finishEditingSectionTitle,"cancel-editing":function($event){return _setup.surfaceSectionsStore.stopRenamingSection()},"resize":_setup.emitHeaderResize}}),_vm._v(" "),(_setup.xSectionSpecificButtons)?_c('div',{class:[
      'flex flex-row space-s-1 surface-section-action-buttons',
      _setup.shouldHideSectionButtonsWhenDragging && 'invisible',
    ]},_vm._l((_setup.sectionSpecificButtons),function(button){return _c(_setup.isMap ? _setup.OzPlainButton : _setup.OzSkewedButton,{key:button.id,tag:"component",class:[
        'flex-shrink-0',
        _setup.isMap
          ? ['w-6 h-6 p-1']
          : [
              'transition-shadow motion-reduce:transition-none',
              {
                'hover-overlay-light': _setup.backgroundLuminance === 'light',
                'hover-overlay-dark': _setup.backgroundLuminance === 'dark',
              },
            ],
      ],style:(!_setup.isMap && { backgroundColor: _setup.skinPrimaryVariantColorAsRGB || _setup.backgroundColor }),attrs:{"id":button.id,"data-cy":button.testId,"size-preset":_setup.isMap ? _setup.OzPlainButtonSizePreset.H24px : _setup.OzSkewedButtonSizePreset.H40px,"color-scheme":_setup.isMap && _setup.OzPlainButtonColorScheme.Secondary,"title":button.label,"aria-label":button.label,"dark-mode":_setup.isMap ? _setup.colorScheme === 'dark' : _setup.backgroundLuminance === 'dark',"dir":_setup.dir},on:{"click":button.onClick}},[_c(_setup.OzIcon,{attrs:{"name":button.icon,"size":16}})],1)}),1):_vm._e(),_vm._v(" "),(_setup.isGrid && _setup.sectionAddPostButton.shouldShow)?_c(_setup.OzBaseButton,{class:[
      'flex',
      'items-center',
      'justify-center',

      'transition-all motion-reduce:transition-none',

      // Size & shape
      'mt-3 tablet-portrait:mt-4',
      'rounded-lg',
      'w-full h-8',
      'p-0',

      // Base
      {
        'bg-[rgba(255,255,255,0.32)]': _setup.backgroundLuminance === 'light',
        'bg-[rgba(0,0,0,0.24)]': _setup.backgroundLuminance === 'dark',
      },
      'backdrop-filter backdrop-blur-sm',
      {
        'text-dark-text-200': _setup.backgroundLuminance === 'light',
        'text-light-text-200': _setup.backgroundLuminance === 'dark',
      },

      // Hover
      {
        'hover-hover:hover:bg-light-ui-100': _setup.backgroundLuminance === 'light',
        'hover-hover:hover:bg-dark-ui-100': _setup.backgroundLuminance === 'dark',
      },
      {
        'hover-hover:hover:text-dark-text-100': _setup.backgroundLuminance === 'light',
        'hover-hover:hover:text-light-text-100': _setup.backgroundLuminance === 'dark',
      },

      // Focus
      'focus-visible:outline-none',
      'focus-visible:ring-2',
      {
        'ring-grape-500': _setup.backgroundLuminance === 'light',
        'ring-canary-500': _setup.backgroundLuminance === 'dark',
      },

      // Active
      {
        'hover-hover:active:bg-grape-500': _setup.backgroundLuminance === 'light',
        'hover-hover:active:bg-canary-500': _setup.backgroundLuminance === 'dark',
      },
      {
        'hover-hover:active:text-light-text-100': _setup.backgroundLuminance === 'light',
        'hover-hover:active:text-dark-text-100': _setup.backgroundLuminance === 'dark',
      },
    ],attrs:{"aria-label":_setup.sectionAddPostButton.label,"title":_setup.sectionAddPostButton.label},on:{"click":_setup.sectionAddPostButton.onClick}},[_c(_setup.OzIcon,{attrs:{"name":_setup.sectionAddPostButton.icon,"size":16}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }